export const APP_VERSION = '3.1.1';
export const APP_VERSION_LABEL = `v${APP_VERSION}`;

export const APP_RUN_NUMBER = process.env.REACT_APP_RUN_NUMBER || 'local';
export const APP_RUN_LABEL = APP_RUN_NUMBER === 'local' ? 'Run local' : `Run #${APP_RUN_NUMBER}`;

const rawStage = process.env.REACT_APP_STAGE || 'production';

export const APP_STAGE = rawStage.trim().toLowerCase();
export const IS_STAGING = APP_STAGE === 'staging';
export const APP_STAGE_LABEL = IS_STAGING ? 'STAGING' : 'PRODUCTION';
export const IS_PRODUCTION_STAGE = !IS_STAGING;
